import { IOmniaSession, labels, OmniaModuleId, OmniaObjectType, OmniaService, setDates, str } from "./omnia"
import { IDashboardStock } from "./stocks/model"
import { HoldingNotification, IDashboardNutrition, IDashboardNutritionPlan, IDashboardSeedPlan, IDashboardService, IFieldsService } from "./types"

interface IServiceData {
    Stocks: IDashboardStock[]
    SeedPlans: IDashboardSeedPlan[]
    NutritionPlans: IDashboardNutritionPlan[]
    NutritionInfo: IDashboardNutrition
    Notifications: HoldingNotification[]
}

export class DashboardService extends OmniaService implements IDashboardService {

    private stocks: IDashboardStock[] = []
    private seedPlans: IDashboardSeedPlan[] = []
    private nutritionPlans: IDashboardNutritionPlan[] = []
    private nutritionInfo: IDashboardNutrition = {
        RequirementsToRecalculate: [],
        NMax: []
    }

    private notifications: HoldingNotification[] = []

    static $inject = ["OmniaSession", "OmniaFieldsService"];

    constructor(session: IOmniaSession, private fieldsvc: IFieldsService) {

        super(session, {
            name: str.Modules.Dashboard,
            module: OmniaModuleId.Dashboard,
            dependencies: [fieldsvc]
        })

    }

    protected getRefreshPromise() {

        return this.loadServiceData()

    }

    private loadServiceData() {

        const { holdingId, yearId } = this

        const url = "/api/dashboard/service/data/holding/" + holdingId + "/year/" + yearId

        this.notifications = undefined

        return this.ohttp.get(url).then(r => {

            const data: IServiceData = r.data

            this.stocks = data.Stocks
            this.seedPlans = data.SeedPlans
            this.nutritionPlans = setDates(data.NutritionPlans, ["LastCalculationDate"], true)
            this.nutritionInfo = setupNutritionInfo(data.NutritionInfo)
            this.notifications = data.Notifications

        });

    }

    getFieldService() {
        return this.fieldsvc;
    }

    getStocks() {
        return (this.stocks || []).slice()
    }

    getSeedPlans() {
        return (this.seedPlans || []).slice()
    }

    getNutritionPlans() {
        return (this.nutritionPlans || []).slice()
    }

    getNutritionInfo() {
        return this.nutritionInfo
    }

    getNotifications() {
        return this.notifications
    }

    recheckNotifications() {

        const url = `/api/dashboard/notifications/year/0/check`

        this.notifications = null

        return this.ohttp.post<HoldingNotification[]>(url).then(r => r.data)

    }

    recalculateNMax(): angular.IPromise<any> {

        const year = this.yearId

        const url = `/api/nutrition/v2/nmax/calculate/year/${year}`

        return this.post(url, undefined, { source: OmniaModuleId.Nutrition, type: OmniaObjectType.NutritionNMax })

    }

}

function setupNutritionInfo(info: IDashboardNutrition): IDashboardNutrition {

    if (info) {

        (info.NMax || []).forEach(g => {
            g.GroupName = labels.NMaxGroupId(g.GroupId) || g.GroupName
        })

    }

    return info

}
